<template>
    <main class="m-blog">
        <y-container>
            <y-blog-hero @hero-content="getHeroContent" />
            <y-popular-articles />
        </y-container>
        <y-categories has-categories />
        <y-container>
            <y-email-subscription />
        </y-container>
    </main>
</template>

<script >
    import PageMixin from '@groot-nodes/mixins/Page.js';
    import YBlogHero from '@modules/blog/components/Hero/Hero.vue';
    import YPopularArticles from '@modules/blog/components/PopularArticles/PopularArticles.vue';
    import YEmailSubscription from '@modules/blog/components/EmailSubscription/EmailSubscription.vue';
    import YCategories from '@modules/blog/components/Categories/Categories.vue';

    // Helper
    import { removeSymbol } from '@/helpers/helpers';

    export default {
        name: 'BlogListPage',

        components: {
            YBlogHero,
            YPopularArticles,
            YEmailSubscription,
            YCategories,

        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.heroContent.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.heroContent.seo_meta_description,
                    },
                ],
            };
        },

        /**
         * @inheritdoc
         */
        data() {
            return {
                heroContent: '',
            };
        },
        
        methods: {
            removeSymbol,
            
            /**
             * get Hero content
             *
             * @param {object} value
             */
            getHeroContent(value) {
                this.heroContent = value;
            },
        },
    };

</script>

<style lang="scss" src="../scss/blog.scss"/>
